<template>
    <div
        class="profile-icon"
        :style="{
            backgroundColor: uniqueColorBackground
        }"
    >
        <img v-if="photo" class="w-100 h-100" :src="photoUpdated || photo" />
        <span v-else>{{ initials }}</span>
    </div>
</template>
<script>
export default {
    components: {},
    props: {
        currentActor: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    computed: {
        photoUpdated() {
            let isCurrentActorProfile = false;
            const staffDetails = this.$store.getters["staff/staffDetails"];

            if (
                this.currentActor &&
                staffDetails &&
                this.currentActor.id == staffDetails.id
            ) {
                isCurrentActorProfile = true;
            } else {
                isCurrentActorProfile = false;
            }

            if (
                isCurrentActorProfile &&
                staffDetails.photo_path &&
                !staffDetails.photo_path.includes("no_avatar.png")
            ) {
                return staffDetails.photo_path;
            } else {
                return null;
            }
        },
        initials() {
            if (
                !this.currentActor ||
                (this.currentActor &&
                    (!this.currentActor.firstname ||
                        !this.currentActor.lastname))
            ) {
                return "";
            }
            return `${this.currentActor.firstname[0]}${this.currentActor.lastname[0]}`;
        },
        photo() {
            if (
                this.currentActor.photo_path &&
                this.currentActor.photo &&
                !this.currentActor.photo_path.includes("no_avatar.png")
            ) {
                return this.currentActor.photo_path;
            } else {
                return null;
            }
        },
        uniqueColorBackground() {
            if (
                !this.currentActor ||
                (this.currentActor && !this.currentActor.fullname)
            ) {
                return "";
            }

            const getHashOfString = str => {
                let hash = 0;
                for (let i = 0; i < str.length; i++) {
                    // tslint:disable-next-line: no-bitwise
                    hash = str.charCodeAt(i) + ((hash << 5) - hash);
                }
                hash = Math.abs(hash);
                return hash;
            };

            const normalizeHash = (hash, min, max) => {
                return Math.floor((hash % (max - min)) + min);
            };

            const generateHSL = (name, saturationRange, lightnessRange) => {
                const hash = getHashOfString(name);
                const h = normalizeHash(hash, 0, 360);
                const s = normalizeHash(
                    hash,
                    saturationRange[0],
                    saturationRange[1]
                );
                const l = normalizeHash(
                    hash,
                    lightnessRange[0],
                    lightnessRange[1]
                );
                return [h, s, l];
            };

            const HSLtoString = hsl => {
                return `hsl(${hsl[0]}, ${hsl[1]}%, ${hsl[2]}%)`;
            };

            const generateColorHsl = (id, saturationRange, lightnessRange) => {
                return HSLtoString(
                    generateHSL(id, saturationRange, lightnessRange)
                );
            };

            const getRange = (value, range) => {
                return [
                    Math.max(0, value - range),
                    Math.min(value + range, 100)
                ];
            };

            // NOTE: Setting for color saturation
            const range = 10;
            const saturation = 90;
            const lightness = 80;

            const saturationRange = getRange(saturation, range);
            const lightnessRange = getRange(lightness, range);

            const color = generateColorHsl(
                this.currentActor.fullname,
                saturationRange,
                lightnessRange
            );

            return color;
        }
    }
};
</script>
<style scoped>
.profile-icon {
    width: 30px;
    height: 30px;
    border-radius: 100%;
    border: 1px solid #ccc;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
}
.profile-icon span {
    size: 12px;
    height: 18px;
    color: rgb(33, 37, 41);
    font-weight: 500;
}
</style>
